import { render, staticRenderFns } from "./UploadList.vue?vue&type=template&id=3b01b332&scoped=true&"
import script from "./UploadList.vue?vue&type=script&lang=js&"
export * from "./UploadList.vue?vue&type=script&lang=js&"
import style0 from "./UploadList.vue?vue&type=style&index=0&id=3b01b332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b01b332",
  null
  
)

export default component.exports